import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { useCreateLandingPage } from '../../../../../common/components/CreateRemoteEntity/CreateRemoteLandingPage';
import {
  openAddPromoterModal,
  useModalActions,
} from '@mm/state/modules/modalsState/actions';
import { StoreState } from '@mm/state/store-interfaces';
import { useCreatePromoter } from '../../../promote/PromotersPanel/use-create-promoter';
import { useCreateSMSKeyword } from '../../../smsKeywords/SMSKeywordsPanel/use-create-sms-keyword';
import { useCreateStartBotPromoterByType } from '../../../startBotPromoters/common/use-create-start-bot-promoter-by-type';
import { selectInstagramAccountId } from '@mm/state/selectors/instagramSelectors';
import { useInstagramCRUDActions } from '@mm/state/actions/InstagramCRUDActions';
import { useEffect } from 'react';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { UIFilterStarterKindType } from '@mm/state/model/ChatStarterModel';

export const useCreateChatStarter = () => {
  const createCustomerChat = useCreateStartBotPromoterByType('customer_chat');
  const createCommentGuard =
    useCreateStartBotPromoterByType('fb_comment_guard');
  const createIgCommentGuard = useCreateStartBotPromoterByType(
    'instagram_comment_guard',
  );
  const { createPromoter } = useCreatePromoter();
  const { createLandingPage } = useCreateLandingPage();
  const { createKeyword } = useCreateSMSKeyword();
  const { openInstagramConnectModal } = useModalActions();

  const dispatch: Dispatch<StoreState> = useDispatch();
  const openFacebookOptinTypeSelectModal = () => {
    dispatch(openAddPromoterModal(createPromoter));
  };
  const instagramAccountId = useSelector(selectInstagramAccountId);

  const createChatStarter = (starterKind?: UIFilterStarterKindType) => {
    switch (starterKind) {
      case 'comment_guard':
        return createCommentGuard();
      case 'customer_chat_widget':
        return createCustomerChat();
      case 'share_links':
        return createPromoter('link');
      case 'landing_pages':
        return createLandingPage();
      case 'sms_keywords':
        return createKeyword({ withoutBotActivation: true });
      case 'facebook_optin':
        return openFacebookOptinTypeSelectModal();
      case 'optin_popups':
        return createPromoter('optin');
      case 'instagram_welcomer':
        return instagramAccountId
          ? createPromoter('instagram_welcomer')
          : openInstagramConnectModal();
      case 'instagram_story_mention':
        return instagramAccountId
          ? createPromoter('instagram_story_mention')
          : openInstagramConnectModal();
      case 'instagram_story_reaction':
        return instagramAccountId
          ? createPromoter('instagram_story_reaction')
          : openInstagramConnectModal();
      case 'instagram_comment_guard':
        return instagramAccountId
          ? createIgCommentGuard()
          : openInstagramConnectModal();
      case 'instagram_live_comment_guard':
        return instagramAccountId
          ? createPromoter('instagram_live_comment_guard')
          : openInstagramConnectModal();
      default:
        throw new Error('Found unknown chat starter type');
    }
  };

  return { createChatStarter };
};
